module.exports = __webpack_public_path__ + "img/Quility_logo_desktop.2e7839a5.svg";